<template>
	<div>

		<v-row class="mb-5">
			<v-col cols="8" md="6">
				<v-text-field
				v-model="search_query"
				:placeholder="$lang.LINE_SEARCH"
				outlined
				rounded
				dense
				@keyup="getLineList"
				hide-details
				append-icon="mdi-magnify"
				></v-text-field>
			</v-col>
			<v-col cols="4" md="6" class="text-right">
				<span @click="$router.push({name:'add-line'})" class="cursor-pointer">
					<span class="secodry-text-4 mr-3 ">{{$lang.ADD_A_LINE.toUpperCase()}}</span>
					<v-btn color="primary" fab small depressed >	
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</span>
			</v-col>
		</v-row>
		<!--  -->
		<div>
			<v-data-table
			:headers="headers"
			:items="line_list"
			:hide-default-footer="true"
			:disable-sort="true"
			:items-per-page="$keys.PAGE_LENGTH"
			class="elevation-1 custome-header-bg custome-table-body"
			:loading="table_loading"
			>
			<template v-slot:item.action="{ item }">
				<v-btn small fab text @click="$router.push({name:'edit-line',params:{line_id:encript(item.id)}})">
					<img src="@/assets/edit.svg" alt="img">
				</v-btn>	
				<v-btn small fab text class="ml-2"
				@click="setDeleteDialog(item)">	
				<img src="@/assets/delete.svg" alt="img">
			</v-btn>
			<v-btn small fab text @click="$router.push({name:'line-details',params:{line_id:encript(item.id)}})">	
				<img src="@/assets/arrow-right.svg" alt="">	
			</v-btn>	
			
		</template>	
		<!--  empty state  -->
		<template v-slot:no-data>
			<empty-list :message="$lang.EMPTY_LINE" :type="$keys.EMPTY_TYPE_2"/>
		</template>	
	</v-data-table>
	<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
	@input="getLineList"></v-pagination>

</div>

<confirm-delete-dialog :dialog="dialog" @update-line-list="getLineList"/>

</div>
</template>

<script type="text/javascript">
export default {
	components: {
		ConfirmDeleteDialog:()=>import('./child/ConfirmDeleteDialog')
	},

	data () {
		return {
			total_page_count:1,
			page_number:1,
			table_loading:false,
			search_query:"",
			line_list:[],
			headers: [
			{ text: 'Line ID', align: 'start', value: 'line_id'},
			{ text: 'Name', align: 'start', value: 'line_name'},
			{ text: 'Area', value: 'area' },
			{ text: '', value: 'action', align: 'end' },
			],
			/*FILTER*/
			filter_data:{
				retailer_id_list:[],
				status_list:[],
				type_list:[],
				filter_date_from:"",
				filter_date_to:"",
			},
			dialog:{
				flag:false,
				line_name:"",
				line_id:"",
			}
		}
	},
	created(){
		this.$store.dispatch('setPageLoader', true)
		this.getLineList(false)
	},
	methods:{
		/* fetching shipment list */ 
		getLineList(is_cancel=true){
			const self=this
			self.table_loading=true
			let params={
				search_query:this.search_query
			};
			const successHandler = (response) => {
				if (response.data.success){
					self.line_list=response.data.line_list
				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)

			};

			self.request_GET( self,self.$urls.LINE_LIST,params,successHandler,null,null,finallyHandler,is_cancel)
		},
		setDeleteDialog(line){
			console.log(line)
			this.dialog.line_name=line.line_name
			this.dialog.line_id=line.id
			this.dialog.flag=true
		}
		
	}
}


</script>